export const getCompletionsVsSendsMetrics = (state: Record<string, any>) =>
  state.iterableGoals.goalAnalytics.completionsVsSendsMetrics;
